import { compose } from 'redux'
import { withHandlers } from 'recompose'

export default compose(
  withHandlers({
    // someHandler: props => value => {}
  })
)
